import DesktopNavbar from '@components/navbar/DesktopNavbar';
import useIsDesktop from '@components/navbar/lib/useIsDesktop';
import { useNavbarData } from '@components/navbar/lib/useNavbarData';
import MobileNavbar from '@components/navbar/MobileNavbar';
import React from 'react';

const Navbar: React.FC = () => {
    const isDesktop = useIsDesktop(850);
    const { user, navMenuItems } = useNavbarData();

    if (isDesktop) {
        return <DesktopNavbar user={user} navMenuItems={navMenuItems} />;
    }

    return <MobileNavbar user={user} navMenuItems={navMenuItems} />;
};

export default Navbar;
